import { useMutation } from "@tanstack/react-query"
import { updateMotibellDailyStatistic } from "lib/api/motibell/updateMotibellDailyStatistics"

const useUpdateMotibellDailyStatisticMutate = () => {
  return useMutation(({ motibellNo, cntNames }) =>
    updateMotibellDailyStatistic({ motibellNo, cntNames })
  )
}

export default useUpdateMotibellDailyStatisticMutate
